import * as React from 'react';
import Image from '@sls-react/components/Image';
import classNames from 'classnames';
import DEFAULT_AVATAR from '@sls-react/static/missing-avatar.png';

type AvatarProps = Omit<React.ComponentProps<typeof Image>, 'src'> & {
  avatarUrl?: string | null;
  size?: 'small' | 'large' | 'xl' | '2xl';
};

export const Avatar: React.FC<AvatarProps> = ({
  avatarUrl,
  className,
  size,
  ...props
}) => (
  <Image
    className={classNames(
      'border-2 border-grey-200 rounded-full object-cover flex-shrink-0 max-w-none',
      {
        'w-6 h-6': size === 'small', // 24px
        'w-10 h-10': !size, // 40px
        'w-14 h-14': size === 'large', // 56px
        'w-24 h-24': size === 'xl', // 96px
        'w-28 h-28': size === '2xl', // 112px
      },
      className,
    )}
    alt="avatar"
    {...props}
    src={avatarUrl || DEFAULT_AVATAR}
  />
);
